import { useNavigate } from "react-router-dom";
import { useMonteurT } from "@/i18n/monteur";
import MonteurWeltSuche from "@/components/MonteurWeltSuche";
import { ArrowLeft } from "lucide-react";

/**
 * KARTEN-HOME · Teil 1 (Juni 2026) — dünne Nachschlage-Seite (Entscheidung 1a).
 * Bettet die bestehende Welt-Suche unverändert ein; Zurück führt zum Hub.
 */
export default function MonteurSuche() {
  const navigate = useNavigate();
  const t = useMonteurT();
  return (
    <div className="min-h-screen bg-slate-50" data-testid="monteur-suche">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-lg mx-auto px-5 py-4 flex items-center gap-3">
          <button
            onClick={() => navigate("/monteur")}
            data-testid="monteur-suche-back"
            aria-label={t("tasks.backAria")}
            className="text-slate-500 hover:text-slate-900 p-2 -ml-2"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <h1 className="font-heading text-lg font-bold text-slate-900">
            {t("home.searchTitle")}
          </h1>
        </div>
      </header>
      <div className="max-w-lg mx-auto px-5 py-6">
        <MonteurWeltSuche />
      </div>
    </div>
  );
}
